import { IRiskAppHeatMapColor } from '../types';
import { EntityService } from './EntityService';

export class RiskAppHeatMapColorService extends EntityService<IRiskAppHeatMapColor> {
    constructor() {
        super(`/RiskAppHeatMapColors`);
    }

    public async readSelectedBandColors(): Promise<IRiskAppHeatMapColor[]> {

        const colors: IRiskAppHeatMapColor[] =
            (await this.axiosGet(
                `${this.entityUrl}/GetRiskAppHeatMapSelectedBandColors()`
                + `?$select=ID,NumBands,ImpactLevel,ProbabilityLevel,ColorHex,CellTitle`
            )).data.value;

        return colors;
    }

    // public async readSelectedBandColors(): Promise<IRiskAppHeatMapColor[]> {

    //     const colors: IRiskAppHeatMapColor[] =
    //         (await this.axiosGet(
    //             `${this.entityUrl}/GetRiskAppHeatMapSelectedBandColors()`
    //         )).data.value;

    //     return colors;
    // }

}